export default __webpack_public_path__ + "static/media/quasi_reg_det_topology_reduced.5434228a.png";